import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { ResolutionFactoCohabitationFormVM } from 'mutation/view-models/resolution-facto-cohabitation';
import { DateTime } from 'luxon';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformCohabitationDeFacto } from 'shell/utils/consult-person/response-transformer/cohabitation-de-facto/cohabitation-de-facto';

export const transformerResolutionFactoCohabitationData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): ResolutionFactoCohabitationFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti.datiSoggetto || [];

  const personData = transformPerson(person);

  const citizenship = transformCitizenship(person);

  const familyCoexistence = transformFamilyCoexistence(person);

  const cohabitant = transformCohabitationDeFacto(person);

  return {
    dichiarante: person,
    person: personData || undefined,
    citizenship: citizenship,
    familyCoexistence: familyCoexistence,
    editDataControl: {
      dateValidity: DateTime.now(),
    },
    cohabitant: cohabitant,
    cohabitationData: {
      file: null,
      municipality: null,
      list: '',
      dateNotification: null,
      professionist: '',
      eventItaly: null,
      eventForeign: null,
      endCohabitationDate: null,
      protocol: '',
      reasonTermination: '',
    },
  };
};
